import { useState } from 'react';
import { FashLogo } from '../../assets/img';
import styles from '../../assets/styles/Admin/AdminSidebar.module.scss';
import { SidebarData } from './sidebarData';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { motion } from 'framer-motion';

const Sidebar = () => {
	const navigate = useNavigate();
	const [expandedNav, setExpandedNav] = useState(-1);

	return (
		<div className={styles.sidebar}>
			<div>
				<img src={FashLogo} className={styles.sb_logo} alt="Fash logo" />
			</div>
			<nav className={styles.sb_nav}>
				{SidebarData?.map((sidebar, i) => (
					<div
						key={i}
						className={`${styles.sb_nav__item} ${
							window.location.pathname === sidebar.link
								? styles.sb_nav__item__active
								: ''
						}`}
						onClick={() => {
							if (sidebar.subNav !== undefined) {
								if (expandedNav === i) {
									setExpandedNav(-1);
								} else {
									setExpandedNav(i);
								}
							} else {
								// menuClicked();
								navigate(sidebar.link);
							}
						}}>
						{sidebar.icon}
						<p>{sidebar.title}</p>
					</div>
				))}
			</nav>
		</div>
	);
};

const AdminSidebar = ({ showSidebar, menuClicked }) => {
	const isMobile = useMediaQuery({
		query: '(max-width: 768px)',
	});

	if (isMobile) {
		return (
			<>
				{showSidebar && (
					<motion.div
						initial={{
							opacity: 0,
						}}
						animate={{
							opacity: 1,
							transition: {
								duration: 0.2,
							},
						}}
						exit={{
							opacity: 0,
							transition: {
								duration: 0.2,
							},
						}}
						className={styles.sidebar__container}>
						<motion.div
							initial={{
								x: -100,
							}}
							animate={{
								x: 0,
								transition: {
									duration: 0.2,
								},
							}}
							exit={{
								x: -100,
								transition: {
									duration: 0.2,
								},
							}}>
							<Sidebar />
						</motion.div>
						<div onClick={menuClicked}></div>
					</motion.div>
				)}
			</>
		);
	}

	return <Sidebar />;
};

export default AdminSidebar;
